import { IfAbility } from '@efdigital/ll-addon-auth';
import BrandingSection from '@efdigital/ll-admin-v2/components/client-edit/branding-section.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import {
  EditRecord,
  initialState,
} from '@efdigital/ll-admin-v2/components/edit-record.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

const BrandingRoute: TemplateOnlyComponent<Signature> = <template>
  <IfAbility @ability="clients" @atLeast="viewer">
    <:if>
      <EditContext as |context|>
        <EditRecord
          @editLabel="Edit Branding"
          @item={{@model.client}}
          @context={{context}}
          @buttonSize="btn-md"
          @initialState={{initialState @model.client}}
          @maxDepth={{1}}
        >
          <:form as |uniqueId isReadOnly|>
            <BrandingSection
              @client={{@model.client}}
              @uniqueId={{uniqueId}}
              @isReadOnly={{isReadOnly}}
            />
          </:form>
        </EditRecord>
      </EditContext>
    </:if>
    <:else>
      <div class="alert alert-warning">
        You do not have permission to view or manage branding for this client.
      </div>
    </:else>
  </IfAbility>
</template>;

export default BrandingRoute;
